import React, {Component} from "react";
import {Link, NavLink, withRouter} from "react-router-dom";

class TopLineMenu extends Component {
	render() {
		const {location} = this.props;
		const pathname = location.pathname;

		return (
			<ul className="topline__menu">
				<li className={`topline__menu__item green ${pathname === '/top-live' && 'active'}`}>
					<NavLink to="/top-live">Топ линия LIVE</NavLink>
				</li>
				<li className={`topline__menu__item red ${pathname === '/' && 'active'}`}><NavLink to="/">LIVE</NavLink>
				</li>
				<li className={`topline__menu__item orange ${pathname === '/live-soon' && 'active'}`}>
					<NavLink to="/live-soon">LIVE скоро</NavLink></li>
			</ul>
		);
	}
}

export default withRouter(TopLineMenu);


// WEBPACK FOOTER //
// ./src/app/pages/Main/TopLine/TopLineMenu.js